export default "__VITE_ASSET__CbukHcfk__"